<template>
    <b-card no-body>
        <b-card-header class="border-0">
            <h3 class="mb-0">{{ $t('usuarios') }}</h3>
        </b-card-header>

        <el-table class="table-responsive table" header-row-class-name="thead-light" :data="usuarios">
            <el-table-column :label="$t('nombre')" prop="nombre" min-width="140px">
                <template v-slot="{ row }">
                    <span class="status">{{ row.nombre }}</span>
                </template>
            </el-table-column>

            <el-table-column :label="$t('apellido')" min-width="150px" prop="apellido">
                <template v-slot="{ row }">
                    <span class="status">{{ row.apellido }}</span>
                </template>
            </el-table-column>

            <!--el-table-column :label="$t('rut')" min-width="150px" prop="Rut">
                <template v-slot="{ row }">
                    <span class="status">{{ row.rut }}</span>
                </template>
            </el-table-column-->

            <el-table-column :label="$t('rol')" min-width="150px" prop="Rol">
                <template v-slot="{ row }">
                    <span class="status">{{ row.rol }}</span>
                </template>
            </el-table-column>

            <el-table-column v-if="!$route.params.id" :label="$t('empresa')" min-width="170px" prop="Empresa">
                <template v-slot="{ row }">
                    <span class="status">{{ row.empresa }}</span>
                </template>
            </el-table-column>

            <el-table-column :label="$t('accion')" min-width="110px" prop="action">
                <template v-slot="{ row }">
                    <b-row>
                        <b-col>
                            <router-link :to="{ name: 'usuario-detalle', params: { id: row.id } }">
                                <a variant="primary" class="btn-create-new">
                                    <i class="fas fa-eye"></i>
                                </a>
                            </router-link>
                        </b-col>
                        <b-col>
                            <a @click="deleteRow(row.id)" variant="primary" class="btn-create-new">
                                <i class="fas fa-trash" style="color: red; cursor: pointer;"></i>
                            </a>
                        </b-col>
                    </b-row>
                </template>
            </el-table-column>
        </el-table>

        <!-- <b-card-footer class="py-4 d-flex justify-content-end">
            <base-pagination v-model="currentPage" :per-page="10" :total="50"></base-pagination>
        </b-card-footer> -->
    </b-card>
</template>
<script>
import userService from '@/api/userService';
import empresaService from '@/api/empresaService';
import { Table, TableColumn } from 'element-ui'
export default {
    name: 'light-table',
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    data() {
        return {
            usuarios: [],
            currentPage: 1
        };
    },
    async beforeMount() {
        try {
            if (this.$route.params.id > 0)
                this.usuarios = await empresaService.getUsersByEmpresa(this.$route.params.id);
            else
                this.usuarios = await userService.getAll();
        } catch (error) {
            console.error('Error fetching ingresos:', error);
        }
    },
    methods: {
        deleteRow(id) {
            Swal.fire({
                title: this.$t('estas_seguro'),
                text: this.$t('confirma_eliminar'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: this.$t('si_eliminar'),
                cancelButtonText: this.$t('cancelar')
            }).then(async (result) => {
                if (result.isConfirmed) {

                    Swal.fire({
                        html: `<div style="display: flex; align-items: center; justify-content: center;"> 
                      <img src="/img/others/loading.gif" alt="Loading" style="width: 50px; height: 50px; margin-right: 15px;">
                        <div>
                            <h3 style="color: #006393;">Eliminando...</h3>
                        </div>
                    </div>`,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    });

                    const response = await userService.deleteBy(id);
                    if (!response) {
                        Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: this.$t('error')
                        });
                        return;
                    }
                    if (this.$route.params.id > 0)
                        this.usuarios = await empresaService.getUsersByEmpresa(this.$route.params.id);
                    else
                        this.usuarios = await userService.getAll();

                    Swal.fire({
                        text: this.$t('eliminado_correctamente'),
                        icon: "success",
                        showConfirmButton: false,
                        timer: 2000,
                        background: '#f8f9fa',
                        customClass: {
                            title: 'swal-title',
                            icon: 'swal-icon',
                        },
                    });
                }
            });

        },
    }
}
</script>
